"use client"

import { Col, Row } from "antd";

import FormSearchSkeleton from "@/components/hotel/hotels/FormSearch/index.skeleton";
import BannerDealsSkeleton from "@/components/common/BannerDeals.skeleton";
import PromotionsSkeleton from "@/components/common/Promotions/index.skeleton";
import HotelGoodPricesCRSSkeleton from "@/components/home/Deals/HotelGoodPrices/index.crs.skeleton";

const HotelsLoading = () => {
  return (
    <Row className="hotels" justify='center'>
      <Col span={24} className="hotels__searching" style={{ marginBottom: '9rem' }}>
        <FormSearchSkeleton />
      </Col>
      <Col span={24}>
       <BannerDealsSkeleton />
      </Col>
      <Col span={24} className="hotels__promations">
        <PromotionsSkeleton />
      </Col>

      <Col span={24}>
        <div className="hotels__goodprices">
          <HotelGoodPricesCRSSkeleton />
        </div>
      </Col>
    </Row>
  )
}

export default HotelsLoading;